<template>
  <div>
    <ExtensionOptionEvent :assetComponent="assetComponent" :form="form" />
  </div>
</template>

<script>
import SetExtension from "../../models/commands/SetExtension";
import ExtensionOptionEvent from "../forms/options/ExtensionOptionEvent";
import dateConverter from "../../../../utils/converters/date.converter";
import ExtensionOption from "../../../../models/contract/ExtensionOption";
export default {
  components: {
    ExtensionOptionEvent
  },
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let extension = null;
      if (this.assetComponent.extension !== null) {
        extension = this.assetComponent.extension;
        this.$set(extension, 'isExtension', true);
      } else {
        extension = ExtensionOption.createNew();
        this.$set(extension, 'isExtension', false);
      }

      this.form = extension;
    },

    cancel() {
      this.init();
    },

    save() {
      let extension = null;

      if (this.form.isExtension) {
        extension = ExtensionOption.createFromData(this.form);
      }

      const command = new SetExtension(
        this.assetComponent.idInDB,
        extension
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
